import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

const FeaturedSlides = ({ content, title, loading }) => {
    const prevButtonRef = useRef(null);
    const nextButtonRef = useRef(null);
    const [swiper, setSwiper] = useState(null);

    useEffect(() => {
        if (!swiper || !prevButtonRef.current || !nextButtonRef.current) return;

        swiper.params.navigation.prevEl = prevButtonRef.current;
        swiper.params.navigation.nextEl = nextButtonRef.current;
        swiper.params.navigation.disabledClass = 'opacity-30 hover:opacity-30';

        swiper.navigation.init();
        swiper.navigation.update();

        swiper.on('slideChange', () => {
            setTimeout(() => {
                swiper.navigation.update();
            }, 10);
        });
    }, [swiper, prevButtonRef.current, nextButtonRef.current]);

    return (
        <div className="my-10">
            <h3 className="text-2xl xl:text-4xl text-secondary font-bold mb-4 xl:mb-8">{title}</h3>

            {loading ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 xl:gap-10 opacity-20">
                    {[...Array(4)].map((_, index) => (
                        <div
                            key={index}
                            role="status"
                            className="flex items-center justify-center h-0 pb-[90%] md:pb-[103%] max-w-sm bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="relative">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={3.4}
                        modules={[Navigation]}
                        onSwiper={(swiperInstance) => {
                            setSwiper(swiperInstance);
                        }}
                        breakpoints={{
                            1024: { slidesPerView: 3.4 },
                            768: { slidesPerView: 2.2 },
                            0: { slidesPerView: 1.2 },
                        }}
                    >
                        {content.map((item, index) => (
                            <SwiperSlide key={index}>
                                <Link to={`/painel/news/destaques/${item.slug}`} className="group block relative" target="_blank">
                                    <div className="relative h-0 pb-[80%] rounded-xl overflow-hidden border border-neutral-500">
                                        <img
                                            src={item.imagem}
                                            alt={item.titulo}
                                            className="absolute inset-0 w-full h-full object-cover"
                                            loading="lazy"
                                        />

                                        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent transition-all group-hover:scale-y-125" />
                                    </div>

                                    <h3 className="sm:text-lg text-white font-semibold line-clamp-1 leading-tight mt-4 mb-2">
                                        {item.titulo}
                                    </h3>

                                    <p
                                        dangerouslySetInnerHTML={{ __html: item.previa }}
                                        className="text-xs sm:text-sm text-gray-500 line-clamp-3 leading-tight mb-4"
                                    />

                                    <div className="text-sm text-white font-medium flex items-center gap-2">
                                        ver mais
                                        <span className="mt-0.5 w-2 h-2 border-r border-t border-white font-bold transition-all ease-out rotate-45 group-hover:translate-x-[5px]" />
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button
                        ref={prevButtonRef}
                        className="absolute -left-4 top-[35%] -translate-y-1/2 z-[1] w-8 h-8 bg-white bg-opacity-40 opacity-70 rounded-full cursor-pointer transition-all ease-out duration-200 hover:opacity-80 before:content-[''] before:absolute before:top-2.5 before:left-3 before:w-3 before:h-3 before:border-t-2 before:border-l-2 before:-rotate-45"
                    ></button>

                    <button
                        ref={nextButtonRef}
                        className="absolute -right-4 top-[35%] -translate-y-1/2 z-[1] w-8 h-8 bg-white bg-opacity-40 opacity-70 rounded-full cursor-pointer transition-all ease-out duration-200 hover:opacity-80 before:content-[''] before:absolute before:top-2.5 before:right-3 before:w-3 before:h-3 before:border-b-2 before:border-r-2 before:-rotate-45"
                    ></button>
                </div>
            )}
        </div>
    );
};

export default FeaturedSlides;
